"use client";

import * as React from "react";
import { ArrowRight, Search, X } from "lucide-react";
import { CartIcon } from "@/components/shop/CartIcon";
import { ProductsSearch } from "@/components/shop/ProductsSearch";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Saveurs() {
  const [activeFilter, setActiveFilter] = React.useState<"all" | "new">("all");
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  React.useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setSearchOpen(false);
    };
    if (searchOpen) {
      document.addEventListener("keydown", onKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [searchOpen]);
  return <section data-section-id="3960" id="saveurs-et-sérénité" className="bg-[#F8F4ED] text-[#43362F] relative min-h-[80vh] w-full overflow-hidden">
      {}
      <div className="relative z-20 flex items-center justify-between px-6 pt-8 md:px-12 lg:px-16">
        <div className="font-default text-[0.875rem] uppercase tracking-[0.2em] text-[#A77B62]">SLOW MAMA / ACCOMPAGNANTE POSTNATALE</div>
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => setSearchOpen(true)} aria-label="Rechercher" className="rounded-lg border border-[#D5C3B1] bg-[#FCFAF7]/40 backdrop-blur-sm hover:bg-[#EFE6DC]">
            <Search className="size-4" />
          </Button>
          <CartIcon variant="ghost" size="icon" iconSize="size-4" className="rounded-lg border border-[#D5C3B1] bg-[#FCFAF7]/40 backdrop-blur-sm hover:bg-[#EFE6DC]" />
        </div>
      </div>

      {}
      <div className="relative grid grid-cols-1 gap-12 px-6 pt-12 pb-20 md:px-12 lg:grid-cols-12 lg:gap-0 lg:px-16 lg:pt-16">
        {}
        <div aria-hidden="true" className="pointer-events-none absolute top-12 bottom-20 left-[58.333%] hidden w-px lg:block" style={{
        background: "linear-gradient(to bottom, transparent 0%, #D5C3B1 20%, #D5C3B1 80%, transparent 100%)"
      }} />

        {}
        <div ref={leftRef} className={`lg:col-span-7 lg:pr-16 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex items-center gap-3 font-default text-[0.875rem] uppercase text-[#A77B62]" style={{
          letterSpacing: "0.2em"
        }}>
            <span className="inline-block size-3 rounded-lg" style={{
            background: "#C8735B"
          }} />
            <span>BATCH COOKING A DOMICILE</span>
          </div>

          {}
          <h1 className="mt-10 font-default font-normal leading-[1.1] text-[#43362F]" style={{
          fontSize: "clamp(2.5rem, 5vw, 4rem)",
          letterSpacing: "-0.02em"
        }}><span className="block" contenteditable="false" style={{}}></span><span className="!font-serif"><span className="block" contenteditable="false" style={{}}>Repas préparés avec amour pour soutenir</span><span className="block">ta récupération,<span style={{
                color: 'rgb(167, 123, 98)'
              }}><br />à domicile.</span></span></span><span className="block"><span style={{
              color: 'rgb(167, 123, 98)'
            }}></span></span></h1>

          {}
          <p className="mt-10 max-w-xl font-default text-[1.25rem] font-light text-[#43362F]" style={{
          lineHeight: 1.7
        }}>Repas chauds, nourissants, préparés à domicile avant ou pendant ton post-partum. Cuisine pensée pour restaurer le corps et l'esprit.</p>

          {}
          <div className="mt-14 flex flex-wrap items-center gap-3">
            <Link className="cursor-pointer" to="/ContactPage">
              <Button variant="default" className="rounded-lg bg-[#A77B62] px-8 py-6 text-[#FCFAF7] hover:bg-[#43362F] transition-all duration-400" style={{
              letterSpacing: "0.05em"
            }}>
                Réserver ma séance
              </Button>
            </Link>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`lg:col-span-5 lg:pl-16 transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            {}
            <div className="mb-6 flex items-center justify-between font-default text-[0.875rem] uppercase tracking-[0.2em] text-[#A77B62]">
              <span><br /></span>
              <span style={{
              color: "#D5C3B1"
            }}>—</span>
            </div>

            {}
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#EFE6DC]" style={{
            borderRadius: "1rem"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/soin_postnatal_douceur.png" alt="Maman et bébé dans un moment de tendresse" loading="lazy" decoding="async" className="h-full w-full object-cover" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/85c269e3bdb6728ea0eb16de08449ce4.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/607ece8bdd446a6876edddc81768006b.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0-1.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0-1.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0-1.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0-1.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/103b98194c9583a221f49a5b550f31e0.png" src="https://slow-mama.com/wp-content/uploads/2026/07/103b98194c9583a221f49a5b550f31e0.jpg" />
            </div>

            {}
            <div className="mt-6 flex items-end justify-between gap-4">
              <div>
                <p className="font-default text-[1.25rem] text-[#43362F]">Profite de ces précieux moments avec ton bébé, je prends soin des repas et des courses.</p>
                <p className="mt-1 font-default text-[0.875rem] uppercase tracking-[0.2em] text-[#A77B62]">
                  Genève & La Côte
                </p>
              </div>
              <div className="flex items-center gap-2 font-default text-[1rem] text-[#43362F]">
                <span>Découvrir</span>
                <ArrowRight className="size-4" style={{
                color: "#A77B62"
              }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      

      {}
      {searchOpen && <div className="fixed inset-0 z-50 flex flex-col bg-[#F8F4ED]/95 backdrop-blur-xl">
          <div className="flex items-center justify-between border-b border-[#D5C3B1] px-6 py-6 md:px-12 lg:px-16">
            <span className="font-default text-[0.875rem] uppercase tracking-[0.2em] text-[#A77B62]">
              Rechercher sur le site
            </span>
            <Button variant="ghost" size="icon" onClick={() => setSearchOpen(false)} aria-label="Fermer" className="rounded-lg">
              <X className="size-5" />
            </Button>
          </div>
          <div className="flex flex-1 items-start justify-center px-6 pt-16 md:px-12 lg:px-16">
            <div className="w-full max-w-2xl">
              <ProductsSearch value={searchValue} onChange={setSearchValue} placeholder="Rechercher un soin, un atelier..." className="w-full" />
              <p className="mt-6 font-default text-[1rem] text-[#43362F]">
                Appuyez sur <span className="font-default">ESC</span> pour fermer.
              </p>
            </div>
          </div>
        </div>}
    </section>;
}